module.exports = __webpack_public_path__ + "img/tubiao-05.8ab42039.png";